import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/store/store'
import { selectShowModalType, selectCustomTextProps } from '@/store/slices/modal/selector'
import { setShowModalType, setCustomTextModal } from '@/store/slices/modal/action'
import { setModalCallbacks } from '@/store/slices/modal/callbackRegistry'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { useCallback } from 'react'

function useModal() {
  const showModalType = useSelector(selectShowModalType)
  const customTextProps = useSelector(selectCustomTextProps)
  const dispatch = useAppDispatch()

  const setModal = useCallback((value: ShowModalType | null) => {
    dispatch(setShowModalType(value))
  }, [dispatch])

  const setShowModalCustomText = useCallback((
    header: string,
    text: string,
    primaryButtonText?: string,
    secondaryButtonText?: string,
    showSecondaryButton?: boolean,
    onPrimaryClick?: () => void,
    onSecondaryClick?: () => void
  ) => {
    const callbackGeneration = setModalCallbacks({ onPrimary: onPrimaryClick, onSecondary: onSecondaryClick })
    dispatch(setCustomTextModal({ header, text, primaryButtonText, secondaryButtonText, showSecondaryButton, callbackGeneration }))
  }, [dispatch])

  return { showModalType, setShowModalType: setModal, customTextProps, setShowModalCustomText }
}

export default useModal
